import { gate } from 'hub-http/gates';
export const SLPC_AI_CLONE_FLOW = gate('SLPC:CloneWithAI');